import { render, staticRenderFns } from "./DirectCompose.vue?vue&type=template&id=490f5dd4&scoped=true"
import script from "./DirectCompose.vue?vue&type=script&lang=js"
export * from "./DirectCompose.vue?vue&type=script&lang=js"
import style0 from "./DirectCompose.vue?vue&type=style&index=0&id=490f5dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f5dd4",
  null
  
)

export default component.exports